import ProtocolManageTab from './ProtocolManageTab'
export default ProtocolManageTab


// WEBPACK FOOTER //
// ./src/pages/protocol/manage/index.js